import { CustomerTenantModel } from 'app/shared/components/pickers/customer-tenant-picker/models/customer-tenant-model';
import { LaboratoryTenantModel } from 'app/shared/components/pickers/laboratory-tenant-picker/models/laboratory-tenant-model';

export class TenantSelectorModel {
  public customerTenant: CustomerTenantModel;
  public displayCustomerTenantPickerFlag = false;
  public displayLaboratoryTenantPickerFlag = false;
  public laboratoryTenant: LaboratoryTenantModel;
}
